import { types } from '../types/types';

const initialState = {
  forms: [],
  selectedForm: null,
  loading: false,
};

export const supportFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUPPORT_FORM_SET_LIST:
      return {
        ...state,
        forms: action.payload || [],
        loading: false,
      };
    case types.SUPPORT_FORM_SET_SELECTED:
      return {
        ...state,
        selectedForm: action.payload || null,
        loading: false,
      };
    case types.SUPPORT_FORM_SET_LOADING:
      return {
        ...state,
        loading: !!action.payload,
      };
    case types.SUPPORT_FORM_CLEAN:
      return {
        ...state,
        selectedForm: null,
      };
    default:
      return state;
  }
};
